import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";
import { mockPosts } from "../data/mockPosts";

const POSTS_COLLECTION    = "posts";
const COMMENTS_COLLECTION = "comments";

export async function seedPostsIfEmpty() {
  try {
    const snapshot = await getDocs(collection(db, POSTS_COLLECTION));
    if (!snapshot.empty) return;
    const batch = writeBatch(db);
    mockPosts.forEach((post) => {
      const ref = doc(collection(db, POSTS_COLLECTION));
      batch.set(ref, { ...post, timestamp: post.timestamp, firestoreId: ref.id });
    });
    await batch.commit();
  } catch (err) {
    console.error("Seed error:", err);
  }
}

export async function fetchAllPosts() {
  try {
    const q = query(collection(db, POSTS_COLLECTION), orderBy("timestamp", "desc"));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return mockPosts;
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch {
    return mockPosts;
  }
}

export async function fetchPostById(id) {
  try {
    const snap = await getDoc(doc(db, POSTS_COLLECTION, id));
    if (snap.exists()) return { ...snap.data(), id: snap.id };
    return mockPosts.find((p) => p.id === id) || null;
  } catch {
    return mockPosts.find((p) => p.id === id) || null;
  }
}

export async function fetchPostsByCategory(category) {
  try {
    const q = query(
      collection(db, POSTS_COLLECTION),
      where("category", "==", category),
      orderBy("timestamp", "desc")
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) return mockPosts.filter((p) => p.category === category);
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch {
    return mockPosts.filter((p) => p.category === category);
  }
}

export async function fetchTrendingPosts(count = 6) {
  try {
    const q = query(
      collection(db, POSTS_COLLECTION),
      where("trending", "==", true),
      orderBy("timestamp", "desc"),
      limit(count)
    );
    const snapshot = await getDocs(q);
  
    if (snapshot.empty) return mockPosts.filter((p) => p.trending).slice(0, count);
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch (err){
    console.error("Error fetching trending posts:", err);
    return mockPosts.filter((p) => p.trending).slice(0, count);
    
  }

  
}

export async function fetchViralPosts(count = 6) {
  try {
    const q = query(
      collection(db, POSTS_COLLECTION),
      where("viral", "==", true),
      orderBy("timestamp", "desc"),
      limit(count)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) return mockPosts.filter((p) => p.viral).slice(0, count);
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch (err){
    console.error(err)
    return mockPosts.filter((p) => p.viral).slice(0, count);
  }
}

export async function fetchLatestPosts(count = 8) {
  try {
    const q = query(
      collection(db, POSTS_COLLECTION),
      orderBy("timestamp", "desc"),
      limit(count)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) return mockPosts.slice(0, count);
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch {
    return mockPosts.slice(0, count);
  }
}

/* ── ADMIN CRUD ───────────────────────────────────────────────── */

export async function createPost(data) {
  const ref = await addDoc(collection(db, POSTS_COLLECTION), {
    ...data,
    timestamp: serverTimestamp(),
    views: 0,
  });
  return ref.id;
}

export async function updatePost(id, data) {
  await updateDoc(doc(db, POSTS_COLLECTION, id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deletePost(id) {
  await deleteDoc(doc(db, POSTS_COLLECTION, id));
}

/* ── COMMENTS ─────────────────────────────────────────────────── */

export async function fetchComments(postId) {
  try {
    const q = query(
      collection(db, POSTS_COLLECTION, postId, COMMENTS_COLLECTION),
      orderBy("timestamp", "desc")
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  } catch {
    return [];
  }
}

export async function addComment(postId, { name, text }) {
  await addDoc(collection(db, POSTS_COLLECTION, postId, COMMENTS_COLLECTION), {
    name,
    text,
    timestamp: serverTimestamp(),
  });
}
